import React, { ReactElement } from 'react';
import { HeadProvider, Title, Link } from 'react-head';
import { localizeType } from '../../commonType';
import withLocalization from '../../components/hoc/withLocalization';

import tmvcsIcon from './Brands/tmvcs/favicon/tmvcs-Favicon.png';

interface FavIconType {
  currentBrand: string;
  localize: localizeType;
}
const Metadata = (props: FavIconType): ReactElement => {
  const pinBrandName: any = new URLSearchParams(window?.location?.search)?.get('brand')?.toLocaleLowerCase() || '';
  const chkBrandName = sessionStorage.getItem('branName');
  if (!chkBrandName) {
    sessionStorage.setItem('branName', pinBrandName);
  }

  const tmvcTitle = props.localize('preview-sales-engine.static-content.copy.pbeo.pbeo-page-title');
  const getIcon = tmvcsIcon;

  const getTitle = tmvcTitle;
  return (
    <>
      <HeadProvider>
        <Title>{getTitle}</Title>
        <Link rel="icon" type="image/png" href={getIcon} sizes="16x16" />
      </HeadProvider>
    </>
  );
};
export default withLocalization(Metadata);
